Advancedformmultiselect.$inject = [
    '$scope', 'DOMPurify'];

export default function Advancedformmultiselect($scope, DOMPurify) {
    const ctrl = this;
    ctrl.selected = [];

    ctrl.MultiSelectsettings = {
        scrollable: false,
        enableSearch: false,
        displayProp: 'Name',
        showCheckAll: true,
        showUncheckAll: true,
        selectedToTop: false,
        dynamicTitle: true,
        smartButtonMaxItems: 3
    };

    ctrl.TranslationTexts = {
        checkAll: 'Select All',
        uncheckAll: 'Unselect All'
    }

    ctrl.getData = function () {
        return ctrl.selected;
    };

    ctrl.getDisplayData = function () {
        // Filter options to get only selected items
        let selectedOptions = ctrl.options.filter(function (option) {
            return ctrl.selected.some(function (selected) {
                return selected.Id === option.Id;
            });
        });

        return selectedOptions;
    }

    ctrl.getStringData = function () {
        // Filter options to get only selected items
        let selectedOptions = ctrl.options.filter(function (option) {
            return ctrl.selected.some(function (selected) {
                return selected.Id === option.Id;
            });
        }); 

        // remove commas from selected options names
        selectedOptions = selectedOptions.map(function (option) {
            return option.Name.replace(/,/g, ''); // Remove commas from names
        }).join(', ');

        return selectedOptions;
    }

    ctrl.setData = function (options) {
        let namesArray = options.split(', ').map(function (name) {
            return name.trim(); // Trim any extra whitespace
        });

        // Filter options to get only those whose name is in the names array
        ctrl.selected = ctrl.options.filter(function (option) {
            return namesArray.includes(DOMPurify.sanitize(option.Name.replace(/,/g, '')));
        });

        $scope.$apply();

        return ctrl.selected;
    };
}
